import { useTranslation } from 'react-i18next';

import { cn } from '@nucleus-commerce/ui/lib/utils';

import { useSignInProviders } from '../hooks/use-sign-in-providers';

export interface SupportContactProps {
  /** `auth:support.<variant>`: which situation the line speaks to. */
  variant: 'signIn' | 'twoFactor';
  className?: string;
}

/**
 * Who to write to when sign-in fails for a reason the person cannot fix themselves. The address
 * comes from the API's SUPPORT_EMAIL; without one the line is not shown.
 */
export function SupportContact({ variant, className }: SupportContactProps) {
  const { t } = useTranslation('auth');
  const email = useSignInProviders().data?.supportEmail;
  if (!email) return null;
  return (
    <p className={cn('text-muted-foreground text-center text-xs leading-relaxed', className)}>
      {t(`support.${variant}`)}{' '}
      <a href={`mailto:${email}`} className="text-primary font-medium hover:underline">
        {email}
      </a>
    </p>
  );
}
